import { Modal } from "bootstrap";
import React, { createRef, useEffect, useState } from "react";
import { acceptApplication, deleteApplication } from "../services/firebase/firebase";

export const EditApplicationModal = React.forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState('Socio de Transito')
    const { data, hideModal } = props

    const doSubmit = () => {
        setLoading(true)
        acceptApplication(data, type)
            .then(response => {
                setLoading(false)
                alert(response)
                hideModal()
            })
            .catch(error => {
                setLoading(false)
                alert(error.code)
                hideModal()
            })
    }

    const doReject = () => {
        deleteApplication(data.email)
            .then(response => {
                alert(response)
                hideModal()
            })
            .catch(error => {
                alert(error.code)
                hideModal()
            })
    }

    useEffect(() => {
        setType(data.type)
    }, [])

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Solicitud de Socio</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-start">
                        <div className='container row'>
                            <label className="form-label">Solicitante</label>
                            <div className="col-sm-12 mb-sm-2 col-md-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="firstname"
                                    value={data?.firstname}
                                    placeholder="Nombre *"
                                    disabled
                                />
                            </div>
                            <div className="col-sm-12 mb-sm-2 col-md-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lastname"
                                    value={data?.lastname}
                                    placeholder="Apellidos *"
                                    disabled
                                />
                            </div>
                            <div className="col-sm-12 mb-sm-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="email"
                                    value={data?.email}
                                    placeholder="Email *"
                                    disabled
                                />
                            </div>
                            <div className="col-sm-12 mb-sm-3">
                                <label className="form-label">Invitado por</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="contact"
                                    value={data?.contact}
                                    placeholder="Contacto *"
                                    disabled
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Tipo de Socio</label>
                                <select className="form-select" value={type} onChange={e => setType(e.target.value)}>
                                    <option value="Socio de Transito">Socio de Tránsito</option>
                                    <option value="Socio Permanente">Socio Permanente</option>
                                    <option value='Socio de Honor'>Socio de Honor</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer justify-content-between'>
                        <button type="button" className="btn btn-danger" onClick={doReject}>
                            Rechazar solicitud
                        </button>
                        <button type="button" className="btn btn-dark" onClick={doSubmit}>
                            {loading ?
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                : 'Aceptar solicitud'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
})

const Application = ({ data: application }) => {
    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
    }

    return (
        <tr>
            <td>{application?.firstname}</td>
            <td>{application?.lastname}</td>
            <td>{application?.email}</td>
            <td>{application?.contact}</td>
            <td>
                <div>
                    <button className="btn btn-sm btn-outline-success me-1"
                        onClick={showModal}>
                        <i className="fa fa-eye" style={{ fontSize: '18px' }} />
                    </button>
                    <EditApplicationModal data={application} hideModal={hideModal} ref={modalRef} />
                </div>
            </td>
        </tr>
    )
}

export default Application;